import { RESET_DATASET } from 'store';

import { SET_PRIMARY_PARAMETER } from './types';
import { RESET_RANDOMIZATION_HYPOTHESIS_TESTING } from '../types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_PRIMARY_PARAMETER:
      return action.primaryParameter;
    case RESET_DATASET:
    case RESET_RANDOMIZATION_HYPOTHESIS_TESTING:
      return null;
    default:
      return state;
  }
};
